import { fonts, colors, textStyles } from '../../../shared/styles';

const white = '#FFF'
const unitTypeButtonWidth = '2.9375rem'

export const styles = {
  buttonHoverStyles: () => `
    .hover-unit-button:hover {
      background: #EEEEEE !important;
    }
  `,
	cardContainer: {
		marginBottom: 20,
    padding: '15px 20px 20px',
    backgroundColor: '#fff',
    boxShadow: colors.cardShadow
	},
	mapTrackingContainer: {
		marginBottom: 20,
    padding: '10px 20px',
		backgroundColor: 'rgb(22, 169, 225)',
    boxShadow: colors.cardShadow,
		borderRadius: 3,
		color: '#fff',
		fontWeight: 'bold'
	},
	mapTrackBetaBadge: {
		color: 'rgb(22, 169, 225)',
		padding: '5px 10px',
		borderRadius: 10,
		fontSize: 12,
		marginRight: 15,
		backgroundColor: 'white'
	},
	viewMapBtn: {
		padding: 10,
		color: 'white',
		float: 'right',
		border: '1px solid white',
		borderRadius: 3
	},
	backIcon: {
		width: 20,
		height: 20,
		color: colors.blue,
	},
	backText: {
		...textStyles.sectionHead,
		color: colors.blue,
	},

	cardSection: {
		marginBottom: 13,
	},
	cardSectionTitle: {
		...textStyles.subHead3,
		margin: '0px 0px 20px',
    fontWeight: 400
	},
	raceName: {
		paddingBottom: 13,
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
	},
	stickyButton: (isMobile) => ({
		position: 'fixed',
		bottom: 0,
		width: isMobile ? '92%' : 282,
		left: isMobile ? '' : '50%',
		marginLeft: isMobile ? '' : '-141px',
		zIndex: 10
	}),
	allResults: {
		textAlign: 'right',
		fontSize: 12,
		color: '#16A9E1'
	},
	eventNameContainer: {
		fontSize: 12,
		fontFamily: 'ProximaNovaRegular',
		alignItems: 'center',
		color: '#4A4A4A'
	},
	dateTime: {
		borderRight: '1px solid lightgrey',
		paddingRight: 10,
		marginRight: 10,
		color: '#9B9B9B'
	},
  claimDescription: {
	  fontSize: 12,
    color: colors.grey,
    textAlign: 'center',
    paddingTop: 8
  },
  claimTooltip: {
    display: 'inline',
    paddingLeft: 4
  },
  claimTooltipIcon: {
	  marginTop: '-2px'
  },
  imperialButtonStyles: {
    border: '1px solid rgb(221, 221, 221)',
    borderRadius: '5px 0px 0px 5px',
    backgroundColor: '#FFFFFF',
    color: 'rgb(155, 155, 155)',
    padding: '7px 14px',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginRight: 0,
    width: unitTypeButtonWidth
  },
  metricButtonStyles: {
    borderLeft: '0px',
    borderTop: '1px solid rgb(221, 221, 221)',
    borderRight: '1px solid rgb(221, 221, 221)',
    borderBottom: '1px solid rgb(221, 221, 221)',
    borderRadius: '0px 5px 5px 0px',
    backgroundColor: '#FFFFFF',
    color: 'rgb(155, 155, 155)',
    padding: '7px 14px',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginLeft: 0,
    width: unitTypeButtonWidth
  },
  metricImperialActiveButton: {
    backgroundColor: 'rgb(22, 169, 225)',
    color: 'rgb(255, 255, 255)',
  }
};

export const summaryStyles = {
	summaryContainer: {
		marginBottom: 45,
	},
	summaryTitle: {
		paddingBottom: 8,
	},
	row: {
		display: 'flex',
		alignItems: 'center',
		paddingBottom: 8,
		marginBottom: 10,
		borderBottom: '1px solid '+ colors.greyLine,
	},
	lastRow: {
		display: 'flex',
		alignItems: 'center',
	},
	labelColumn: {
		...textStyles.sectionHead,
	},
	valueColumn: {
		fontSize: 21,
		lineHeight: '1em',
	},
	valueUnits: {
		fontSize: 14,
		lineHeight: '1em',
		color: colors.grey,
		...fonts.bold,
	}
};

export const splitTable = {
	title: {
		...textStyles.subHead3,
		fontWeight: '400',
		margin: '0 0 20px',
	},
	tableHead: () => ({
		...textStyles.sectionHead,
		paddingBottom: 5,
		textAlign: 'center',
	}),
	leftDatum: (isMobile) => ({
		padding: '15px 0',
		textAlign: 'left',
		fontSize: (isMobile) ? 12 : 18,
		color: colors.textColor,
	}),
	datum: () => ({
		textAlign: 'center',
		color: colors.textColor,
	}),
	rankNumerator: (isMobile) => ({
    whiteSpace: 'nowrap',
    fontSize: isMobile ? 18 : 21,
    lineHeight: '1em'
	}),
	rankArrow: {
		paddingBottom: 3,
		color: colors.grey,
		width: 13,
		height: 13
	},
	paceNumerator: (isMobile) => ({
		fontSize: (isMobile) ? 18 : 21,
		lineHeight: '1em',
	}),
	paceDenominator: {
		fontSize: 11,
		color: colors.grey,
	},
	time: (isMobile) => ({
		paddingTop: (isMobile) ? 0 : 3,
		...fonts.number,
		fontSize: (isMobile) ? 22 : 30,
		lineHeight: '1em',
	}),
	header: {
		paddingBottom: 6,
		paddingTop: 6,
		alignItems: 'center',
		textAlign: 'center',
    borderTop: '1px solid '+ colors.greyLine
	},
	arrow: {
		paddingBottom: 3,
		color: '#9B9B9B',
		fontWeight: '100',
		width: 13,
		height: 13
  }
};



/** WEBPACK FOOTER **
 ** ./components/IRP/body/styles.js
 **/